// TODO move to @change-corgi/config
const stateCodes: Record<string, readonly string[]> = {
	US: [
		'AL',
		'AK',
		'AZ',
		'AR',
		'CA',
		'CO',
		'CT',
		'DE',
		'DC',
		'FL',
		'GA',
		'HI',
		'ID',
		'IL',
		'IN',
		'IA',
		'KS',
		'KY',
		'LA',
		'ME',
		'MD',
		'MA',
		'MI',
		'MN',
		'MS',
		'MO',
		'MT',
		'NE',
		'NV',
		'NH',
		'NJ',
		'NM',
		'NY',
		'NC',
		'ND',
		'OH',
		'OK',
		'OR',
		'PA',
		'RI',
		'SC',
		'SD',
		'TN',
		'TX',
		'UT',
		'VT',
		'VA',
		'WA',
		'WV',
		'WI',
		'WY',
		'AS',
		'FM',
		'GU',
		'MH',
		'MP',
		'PW',
		'PR',
		'VI',
		'AA',
		'AE',
		'AP',
	],
};

const emptyList: readonly string[] = [];

export function getStateCodes({ countryCode }: Readonly<{ countryCode: string }>): readonly string[] {
	return stateCodes[countryCode] || emptyList;
}
